resourcePaths = '{"rootPath":"","assetsPath":""}';function Model() {
    this.constructor = function(args) {
        if (typeof args[0] == "string") {
            if (args[0].toLowerCase() == "v1") {
                var temp = new ModelV1(args[1], args[2], args[3]);
                return temp;
            } else if (args[0].toLowerCase() == "v2") {
                var temp = new ModelV2(args[1], args[2], args[3]);
                return temp;
            } else {
                var temp = new ModelV2(args[0], args[1], args[2]);
                return temp;
            }
        } else {
            var temp = new ModelV1(args[0], args[1], args[2]);
            return temp;
        }

    };

    return this.constructor(arguments);
}